//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Links from './Links.vue';
import Newsletter from './Newsletter.vue';
export default {
  name: 'LinksNewsletter',
  components: {
    Links,
    Newsletter
  },
  props: {
    content: {
      type: Object,

      default() {
        return {};
      }

    }
  }
};